import { Dispatch } from "redux"

import { Api } from "api"
import { ResultModel } from "types/ApiResponse"
import { PromiseAction } from "types/RemoteAction"
import { TagGroupStructure } from "types/Template"

export const fetchTagLabels =
  () =>
  (dispatch: Dispatch): PromiseAction<ResultModel<TagGroupStructure[]>> =>
    dispatch({
      type: "label/FETCH",
      promise: Api.getTagLabels()
    })
